import React, { useEffect, useState } from "react";
import { storage } from "./firebase";
import { getDownloadURL, listAll, ref } from "firebase/storage";
import song from "./cat.mp3";

const App = () => {

	const [asciiList, setAsciiList] = useState(undefined);
	const [listLen, setListLen] = useState(1);
	const [frameNum, setFrameNum] = useState(0);
	const [isPlaying, setIsPlaying] = useState(false);

	const catRef = ref(storage, "cat");

	const play = () => {
		
		if(!isPlaying) {
			const catSong = new Audio(song);
			catSong.loop = true;
			catSong.play();
			setIsPlaying(true);
		}
		
	};

	useEffect(() => {
		listAll(catRef)
			.then(res => Promise.all(
				res.items.map(async itemRef => {
					const url = await getDownloadURL(itemRef);
					return fetch(url);
				})
			))
			.then(async resList => {
				// console.log(await resList[0].text());
				setAsciiList(await Promise.all(resList.map(res => res.text())));
				

			});
	}, []);

	useEffect(() => {
		setFrameNum(0);
		const intervalId = setInterval(async () => {
			if(frameNum > listLen) {
				console.log("==================================");
				setFrameNum(0);
			} else {
				setFrameNum(oldFrameNum => oldFrameNum + 1);
			}
		}, 33);

		return (() => clearInterval(intervalId));
	}, [asciiList]);

	useEffect(() => { 
		setListLen(asciiList?.length); 
		// if(asciiList) {
		// 	play(); 
		// }
	}, [asciiList]);

	useEffect(() => {setFrameNum(0);}, []);

	// useEffect(() => { console.log(frameNum, listLen); }, [frameNum]);

	const displayFrame = asciiList ? asciiList[frameNum % (listLen ? listLen : 1)].replaceAll(" ", "\u00A0") : undefined;

	return (
		asciiList ? 
			<div style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center"
			}}>
				<div style={{
					width: "100%",
					whiteSpace: "pre-line",
					fontFamily: "Consolas",
					fontSize: 10,
					position: "absolute",
					top: -1600,
					left: 70,
					transform: "scale(.3)",
					transformOrigin: "left",
					display: "flex",
					flexDirection: "row"
				}}>
					<div>
						{displayFrame}
					</div>
					<div>
						{displayFrame}  
					</div>
					<div>
						{displayFrame}  
					</div>
					<div>
						{displayFrame}  
					</div>
					<div>
						{displayFrame}  
					</div>

					{/* {test} */}
				</div>
				<div style={{
					position: "relative",
					top: 50
				}}>
					<button onClick={play}>PLAY THE SONG</button>
				</div>
			</div>
			
			: <div style={{
				marginLeft: "auto",
				marginRight: "auto",
				width: 100,
				marginTop: 700,
				fontSize: 50,
				fontFamily: "Consolas",

			}}>
				Loading...
			</div>
	);
};

export default App;